import VueI18n from 'vue-i18n'
import Vue from 'vue'
import { store } from './store';

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: store.config.i18n.locale,
})

function i18nSetup($root: Vue) {
  $root.$watch('$i18n.locale', (locale: string) => {
    store.config.i18n.locale = locale
  })
}

export { i18n, i18nSetup }
